<template>
  <Sprite />
  <router-view />
</template>

<script>
import Sprite from '@/components/icons/Sprite.vue';

export default {
  name: 'App',
  components: { Sprite }
}
</script>

<style>
body, html {
  height: 100%;
  margin: 0;
}

.loading-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-overlay-div {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  border-top-color: #3b8070;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.shimmer {
    background: linear-gradient(90deg, #797678 25%, #ccc8c8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite linear;
    opacity: 0.1;
    height: 20px;
    border-radius: 4px;
    width: 100%;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.loading-row td {
    padding: 10px;
}
</style>
